import { render, staticRenderFns } from "./DataTablesSelectorComponent.vue?vue&type=template&id=13b81b26&"
import script from "./DataTablesSelectorComponent.vue?vue&type=script&lang=js&"
export * from "./DataTablesSelectorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/fi-self-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b81b26')) {
      api.createRecord('13b81b26', component.options)
    } else {
      api.reload('13b81b26', component.options)
    }
    module.hot.accept("./DataTablesSelectorComponent.vue?vue&type=template&id=13b81b26&", function () {
      api.rerender('13b81b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue_datatables/DataTablesSelectorComponent.vue"
export default component.exports